import styled from "styled-components";

export const IndexCtaComponentMainDiv = styled.section`
  > div {
    display: flex;
    gap: 0;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .cta-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 60px;
    max-width: 1140px;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
  .cta-header {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    max-width: 710px;
  }
  .cta-text-container {
    text-align: center;
    > h2 {
    }
  }
  .cta-cards-contaner {
    flex: none;
    grid-template-rows: repeat(1fr, min-content);
    grid-template-columns: repeat(3, minmax(50px, 1fr));
    grid-auto-rows: 1fr;
    justify-content: center;
    gap: 24px;
    width: 100%;
    display: grid;
    position: relative;
    overflow: hidden;
  }
`;
export const IndexCtaCardDiv = styled.section`
  place-self: start;
  width: 100%;
  height:100%;
  border-radius: 16px;
  display:flex;

  
  


  > div {
    border-radius: 16px;
    border: 1px solid #191919;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    flex:1;
  }
  .cta-card-text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 20px;
  }
  .cta-card-text-container {
    > h3 {
      padding: 0;
      margin: 0;
      font-size: 24px;
      font-weight: 500;
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
    }
    p {
      line-height: 1.5em;
    }
  }
  .cta-card-image-wrapper {
    border-radius: 12px;
    align-items: cenet;
    gap: 10px;
    width: 100%;
  }
  .cta-card-image-container {
    height: 278px;
    width: 100%;
    flex: 1;
    border-radius: 12px;

    border: 1px solid red;
  }
`;
